import React, { useContext, useEffect } from "react";
import LayoutContext from "../contexts/layoutContext";
import Navbar from "./navbar";
import Flashes from "./flashes";
import PlayerModal from "./players/playerModal";
import EmailConfirm from "./emailConfirm";
import { NewVersionPopup, RandomAlert } from "./newVersionPopup";
import MobileAppsPromotion from "./mobileAppsPromotion";
import OfficialRatingModal from "./players/officialRatingModal";
import { isMobile } from "react-device-detect";
import { useCookies } from "react-cookie";
import PlayerVerificationModal from "./players/profileVerificationModal";
import LeaderboardModal from "./leaderboards/leaderboardModal";
import ChallengeLeaderboardModal from "./leaderboards/challengeLeaderboardModal";
import InviteModal from "./leaderboards/inviteModal";
import PlayerChampionshipModal from "./players/playerChampionshipDetailModal";

type Props = {
	children: React.ReactNode;
};

const Layout = ({ children, ...props }: Props) => {
	const { bodyClass, history, newVersionAvailable, profile, authenticated, logout } = useContext(LayoutContext);
	const [cookies] = useCookies(["mobile"]);

	useEffect(() => {
		if (isMobile && (!cookies.hideMobileAppsPromotion || cookies.hideMobileAppsPromotion === false)) {
			document.getElementById("mobile-viewport").setAttribute("content", "width=device-width, initial-scale=1");
			document.getElementById("download-ios-app").setAttribute("content", "");
			setTimeout(function () {
				window.scrollTo(0, 0);
			}, 100);
		}
		document.body.dataset.page = bodyClass;
		return () => {
			document.body.dataset.page = null;
		};
	}, [bodyClass]);

	if (isMobile && (!cookies.hideMobileAppsPromotion || cookies.hideMobileAppsPromotion === false)) {
		return <MobileAppsPromotion />;
	}

	return (
		<>
			<div id="app">
				<div className="layout">
					<Navbar history={history} authenticated={authenticated} profile={profile} logout={logout} />
					<main className="main">
						<Flashes />
						{children}
					</main>
					{newVersionAvailable ? <NewVersionPopup /> : null}
					{profile && authenticated && !history.location.pathname.startsWith("/onboarding") ? (
						<>
							<OfficialRatingModal />
							<PlayerModal />
							<PlayerChampionshipModal />
							<LeaderboardModal />
							<ChallengeLeaderboardModal />
							<PlayerVerificationModal />
							<InviteModal />
							<EmailConfirm profile={profile} />
						</>
					) : null}
				</div>
			</div>
		</>
	);
};

export default Layout;
